import { Box, Stack, Grid } from "@mantine/core"
import { useForm } from "@mantine/form"

import { RenderFormSection } from "~/pages/Admin/components/RenderFormSection"
import { TypesFormActionsSection } from "~/pages/Admin/components/TypesFormActionsSection"
import {
  FormConfig,
  FormElement,
  isFormGroupConfig,
} from "~/pages/Admin/components/form.types"

export type TypesFormProps<T> = {
  elements: FormElement[]
  submitLabel: string
  formConfig: FormConfig<T>
  mutate: (values: T) => void
  closeDrawer?: () => void
  cancelLabel?: string
  children?: React.ReactNode
  readonly?: boolean
}

export const TypesForm = <T extends Record<string, unknown>>(
  props: TypesFormProps<T>
) => {
  const form = useForm({
    ...props.formConfig,
    validateInputOnChange: true,
  })

  const handleSubmit = () => {
    props.mutate(form.values)
    form.reset()
    if (props.closeDrawer) {
      props.closeDrawer()
    }
  }

  const isElementHidden = (element: FormElement): boolean => {
    if ("hidden" in element && element.hidden === true) {
      return true
    }

    if (isFormGroupConfig(element)) {
      if (element.isHidden !== undefined) {
        return element.isHidden(form.values)
      }
    }

    return false
  }

  return (
    <>
      <form onSubmit={form.onSubmit(() => handleSubmit())}>
        <Stack h="100%" gap="sm">
          <Grid px="var(--tfg-layout-padding-x)">
            {props.elements.map(
              (element, index) =>
                !isElementHidden(element) && (
                  <RenderFormSection
                    key={`${element.type}-${index}`}
                    element={element}
                    form={form}
                    index={index}
                  />
                )
            )}
          </Grid>
          {props.children && (
            <Box px="var(--tfg-layout-padding-x)">{props.children}</Box>
          )}
        </Stack>
        <TypesFormActionsSection
          form={form}
          closeDrawer={props.closeDrawer}
          cancelLabel={props.cancelLabel}
          submitLabel={props.submitLabel}
          readonly={props.readonly}
        />
      </form>
    </>
  )
}
